import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {supplierActions} from "./supplierSlice";
import {supplierApi} from "~/api";

function* fetchSupplierList(action) {
	try {
		const response = yield call(supplierApi.gets, action.payload);
		yield put(supplierActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch supplier list', error);
		yield put(supplierActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(supplierActions.setFilter(action.payload));
}

export default function* supplierSaga() {
	yield takeLatest(supplierActions.fetchData.type, fetchSupplierList);
	yield debounce(500, supplierActions.setFilterWithDebounce.type, handleSearchDebounce)
}